import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { push as Menu } from "react-burger-menu";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExitToApp from "@mui/icons-material/ExitToApp";
import HomeIcon from "@mui/icons-material/Home";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import GavelIcon from "@mui/icons-material/Gavel";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LoginIcon from "@mui/icons-material/Login";

var styles = {
  bmBurgerButton: {
    display: "none",
  },
  bmBurgerBars: {
    background: "#373a47",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "24px",
    width: "24px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMenu: {
    background: "#373a47",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "inline-block",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

function MobileMenu(props) {
  const { auth } = useSelector((state) => state.customerAuth);
  const location = useLocation();
  const logOut = props.logOut;

  const styleList = { alignItems: "right", display: "contents" };

  const selectedMenu = (route) => {
    return location.pathname === route ? `panel-link-row` : null;
  };

  return (
    <Menu
      width={"100%"}
      styles={styles}
      right
      pageWrapId={"page-wrap"}
      isOpen={props.isOpenMobileMenu}
      onClose={() => props.setIsOpenMobileMenu(false)}
    >
      <List
        sx={{
          width: "100%",
          bgcolor: "background.paper",
        }}
        component="nav"
        dir="ltr"
        aria-labelledby="nested-list-subheader"
      >
        <Link
          to="/"
          className="panel-link"
          onClick={() => props.setIsOpenMobileMenu(false)}
        >
          <ListItemButton className={selectedMenu("/")}>
            <ListItemText primary="خانه" />
            <ListItemIcon style={styleList}>
              <HomeIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link>
        {auth.isAuthenticated ? (
          <>
            {" "}
            <Link
              to="/likes"
              className="panel-link"
              onClick={() => props.setIsOpenMobileMenu(false)}
            >
              <ListItemButton className={selectedMenu("/likes")}>
                <ListItemText primary=" پسند شده ها" />
                <ListItemIcon style={styleList}>
                  <FavoriteIcon className="ms-auto" />
                </ListItemIcon>
              </ListItemButton>
            </Link>
            <Link
              to="/saved"
              className="panel-link"
              onClick={() => props.setIsOpenMobileMenu(false)}
            >
              <ListItemButton className={selectedMenu("/saved")}>
                <ListItemText primary=" ذخیره شده ها" />
                <ListItemIcon style={styleList}>
                  <BookmarkIcon className="ms-auto" />
                </ListItemIcon>
              </ListItemButton>
            </Link>
            <Link
              to="/address"
              className="panel-link"
              onClick={() => props.setIsOpenMobileMenu(false)}
            >
              <ListItemButton className={selectedMenu("/address")}>
                <ListItemText primary="  نشانی ها" />
                <ListItemIcon style={styleList}>
                  <ContactMailIcon className="ms-auto" />
                </ListItemIcon>
              </ListItemButton>
            </Link>
            <Link
              to="/orders"
              className="panel-link"
              onClick={() => props.setIsOpenMobileMenu(false)}
            >
              <ListItemButton className={selectedMenu("/orders")}>
                <ListItemText primary="  سفارش ها" />
                <ListItemIcon style={styleList}>
                  <LocalMallIcon className="ms-auto" />
                </ListItemIcon>
              </ListItemButton>
            </Link>
            <Link
              to="/ticket"
              className="panel-link"
              onClick={() => props.setIsOpenMobileMenu(false)}
            >
              <ListItemButton className={selectedMenu("/ticket")}>
                <ListItemText primary=" پشتیبانی" />
                <ListItemIcon style={styleList}>
                  <SupportAgentIcon className="ms-auto" />
                </ListItemIcon>
              </ListItemButton>
            </Link>
          </>
        ) : null}
        <a
          href="https://blog.meshirt.ir"
          rel="noreferrer"
          target="_blank"
          className="panel-link"
        >
          <ListItemButton className={selectedMenu("/blog")}>
            <ListItemText primary=" بلاگ" />
            <ListItemIcon style={styleList}>
              <NewspaperIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </a>
        <Link
          to="/terms"
          className="panel-link"
          onClick={() => props.setIsOpenMobileMenu(false)}
        >
          <ListItemButton className={selectedMenu("/terms")}>
            <ListItemText primary="قوانین" />
            <ListItemIcon style={styleList}>
              <GavelIcon className="ms-auto" />
            </ListItemIcon>
          </ListItemButton>
        </Link>
        {auth.isAuthenticated ? (
          <ListItemButton
            className="text-danger"
            onClick={() => {
              props.setIsOpenMobileMenu(false);
              logOut();
            }}
          >
            <ListItemText primary="خروج" />

            <ListItemIcon style={styleList}>
              <ExitToApp className="ms-auto text-danger" />
            </ListItemIcon>
          </ListItemButton>
        ) : (
          <Link
            to="/login"
            className="panel-link"
            onClick={() => props.setIsOpenMobileMenu(false)}
          >
            <ListItemButton className={`${selectedMenu("/login")} panel-link`}>
              <ListItemText primary="ورود" />
              <ListItemIcon style={styleList}>
                <LoginIcon className="ms-auto" />
              </ListItemIcon>
            </ListItemButton>
          </Link>
        )}
        <div className=" row justify-content-center">
          <div className="col-12 text-center">
            {" "}
            <a
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=433310&Code=l2VoDovEctncrZ3PB5ja3rZeVvMkE1PH"
            >
              <img
                referrerpolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=433310&Code=l2VoDovEctncrZ3PB5ja3rZeVvMkE1PH"
                alt=""
                style={{ cursor: "pointer" }}
                Code="l2VoDovEctncrZ3PB5ja3rZeVvMkE1PH"
              />
            </a>
          </div>
        </div>
      </List>
    </Menu>
  );
}

export default MobileMenu;
